import { createAction } from '@reduxjs/toolkit';
import { promoMixItemsSlice } from './reducer';

export const fetchPromoMixItems = createAction('promoMixItems/fetchPromoMixItems');

export const { clearPromoMixItems, setPromoMixItems, setIsFetching } = promoMixItemsSlice.actions;
